export interface PricingFeature {
  featureId?: number;     
  featureName: string;
  value:string
}

export enum PackageStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export interface PricingPackage {
  packageId: number;             // optional if new package
  packageName: string;
  description?: string;
  priceMonthly: string;
  priceYearly: string;
  isMonthly: string;
  isYearly:string;
  packageStatus?: PackageStatus;
  featureDetails?: PricingFeature[];
}
